<main class="main">
  <nav class="sidebarLeft sidebar">
    <div class="sidebar-sticky">
      <div class="proj-sidebar-info">
        <span class="icon-left text-secondary"></span>
        <a [routerLink]="[destinoRouter]">   {{'WorkflowCreate.Back' | translate}}</a>
        <div class="mt-3">
          <label for="workflowCode">
            {{ workflowDefinition.workflowCodeCGA }}
          </label>
          <h1 class="text-secondary">
            {{ workflowDefinition.title }}
          </h1>
          <p class="text-secondary">
            {{ workflowDefinition.subtitle
            }}
          </p>
          <a [routerLink]="" aria-label="Link com Instruções" (click)="getInstructions()" class="card-link" referrerpolicy="origin">{{'WorkflowSearch.Instructions' | translate}}</a>
        </div>
      </div>
    </div>
  </nav>
  <div class="wrapper">
    <div class="container-fluid">
      <alert></alert>
      <h2 class="text-primary mb-0">{{'SubmissionLandingPage.ConfirmSubmissionTitle' | translate}}</h2>
      <br>
      {{'SubmissionLandingPage.ConfirmSubmissionText' | translate}}
      <br>
      <br>
      {{'SubmissionLandingPage.ConfirmSubmissionText2' | translate}}
      <br>
      {{'SubmissionLandingPage.ConfirmSubmissionText3' | translate}}
      <div class="d-flex justify-content-between mt-4 mb-50" role="group" aria-label="Botões de Navegação">
        <button type="button" aria-label="RejeitarManifesto" class="btn btn-outline-primary" (click)="rejectManifest()">
          <span class="icon-close"></span>
          <span>{{'SubmissionLandingPage.RejectButton' | translate}}</span>
        </button>
        <button type="button" aria-label="ValidarrManifesto" class="btn btn-primary" (click)="validateManifest()">
          <span class="icon-check"></span>
          <span>{{'SubmissionLandingPage.AcceptButton' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</main>

<!-- FORM FAKE -->
<form id="formGetFile" #cgaGetFileForm="ngForm" name="formGetFile" method="POST" target="_blank" referrerpolicy="origin">
  <input #cgaGetFileFormInput type="hidden" name="h_queryParams" id="h_queryParams" value="">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>

